import React from 'react';
import { appContent } from './App.content';
import styles from './App.module.sass';
import { Container } from '../ui/Container';
import { Button } from '../ui/Button';
import phone from './assets/phone.webp'

import cloud from './assets/cloud-1.webp';
import cloud2 from './assets/cloud-2.webp';
import cloud3 from './assets/cloud-3.webp';

export function App () {

  return (
    <section className={styles.app}>
      <Container className={styles.app__app}>
        <div className={styles.app__content}>
          <div className={styles.app__title}
            dangerouslySetInnerHTML={{ __html: appContent.title }}
          />
          <div className={styles.app__text}
            dangerouslySetInnerHTML={{ __html: appContent.text }}
          />
          <div className={styles.app__button}>
            <Button
              label={appContent.buttonLabel}
              href={appContent.buttonHref}
              variant="simple"
              target="_blank"
              rel="noopener noreferrer"
            />
          </div>
        </div>
        <img src={phone} alt="" className={styles['app__image']} />
      </Container>
      <img  src={cloud} alt="Облако" className={styles['app__cloud-1']} />
      <img  src={cloud2} alt="Облако" className={styles['app__cloud-2']} />
      <img  src={cloud3} alt="Облако" className={styles['app__cloud-3']} />
      <img  src={cloud3} alt="Облако" className={styles['app__cloud-4']} />
    </section>
  );
}
